import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import FooterLogo from "../../assets/img_footer_logo.svg";
import './styles.scss';
import jQuery from "jquery";
import FooterForm from "../contact/FooterForm";

const Footer = () => {
    const [ footerInfo, setFooterInfo ] = useState(null);
    const [isFetching, setIsFetching] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        fetchFooterInfo();
    }, []);

    const fetchFooterInfo = async () => {
        try {
            const { data } = await axios.get("/wp-admin/admin-ajax.php?action=get_footer_info");
            setFooterInfo(data);
            setTimeout(() => {
                jQuery('#footer-nav a').on("click", function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    const href = jQuery(this).attr('href')?.replace("https://www.mylawteam.com/", "");
                    if (href?.length > 0) {
                        navigate(href);
                    } else {
                        navigate("/");
                    }
                    if (jQuery(this).hasClass("search-icon")) {
                        navigate("/articles/");
                    }
                });

            }, 500)
        } catch(err) {
            console.log(err);
        } finally {
            setIsFetching(false);
        }
    }


    const onClickToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }



    return <footer id="footer">
        <div className="footer-top-row">
            <div className="inner-wrapper">
                <FooterForm />
                <div className="footer-menu">
                    <img src={FooterLogo} />
                    <div className="footer-item">
                        <h3>Contact</h3>
                        <p>
                            <span dangerouslySetInnerHTML={{ __html: footerInfo?.address?.block_address }}></span>
                            <a href={`tel:${footerInfo?.address?.block_phone}`}>{footerInfo?.address?.block_phone}</a>
                            <a href={`${footerInfo?.address?.block_direction_url}`} target="_blank">Directions</a>
                        </p>
                    </div>
                    <div className="footer-item">
                        <h3>Quick Links</h3>
                        <div className="footer-menu-wrapper" dangerouslySetInnerHTML={{ __html: footerInfo?.footer?.footer_menu }}></div>
                    </div>
                </div>
            </div>
        </div>
        <div className="footer-legal-wrapper">
            <div className="inner-wrapper">
                <div className="left-block">
                    <span className="to-top" onClick={() => onClickToTop()}>
                        Back to top
                    </span>
                </div>
                <div className="right-block">
                    <span>© {new Date().getFullYear()} {footerInfo?.footer?.footer_legal_name}</span>&nbsp;
                    {
                        footerInfo?.footer?.footer_link?.map((it, index) => {
                            return <span key={index}>
                                <Link to={it?.block_link}>{it?.block_label}</Link>
                                {index<footerInfo?.footer?.footer_link?.length - 1 && <>
                                    &nbsp;&nbsp;|&nbsp;&nbsp;
                                </>}
                            </span>
                        })
                    }
                </div>
            </div>
        </div>
    </footer>
}

export default Footer;